module.exports = __webpack_public_path__ + "static/img/xi_111.5af6820.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_111.jpg
// module id = oScQ
// module chunks = 1